var extractTopLevelDomain=function(domain){if(!domain||domain.length===0){throw new Error("Domain must be specified")}var segments=domain.split(".");if(segments.length<2){throw new Error("Domain '"+domain+"' does hot have the right format.")}var tld=segments.pop();return tld};

export { extractTopLevelDomain };
//# sourceMappingURL=tld.js.map
